import guides from '../content/firm-guide.json';

export const practiceGuides = guides;
